module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre4"
  }, [_vm._v("Kapellenglöcklein auf Hohenhaus")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Die Glocke klingt, still rauscht die Eiche;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nwer hat das kleine Haus erstiegen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nvor dem lebend'ge Zauberreiche"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nin sanfter Pracht entfaltet liegen?")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Wem quillt die volle Seele über,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndaß er das helle Glöcklein läutet?"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nDenn klingt ihr Ton zu uns herüber,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nso weiß man, daß es Glück bedeutet.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2413dca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0017.vue
// module id = 105
// module chunks = 0